import { AtLeast } from "../util/types.util";
import { JobOrder, JobRating } from "./JobOrder";
import { MarinerProfile } from "./MarinerProfile";
import { TrainingOrder } from "./Training";
import { Vessel } from "./Vessel";

export type Dispatch = {
  id?: number;
  startDate: string;
  endDate: string | undefined;
  rating: JobRating;
  profileId: number | undefined;
  profile: MarinerProfile | undefined;
  vesselId: number | undefined;
  vessel: Vessel | undefined;
  dispatchDuration: DispatchDuration | undefined;
  extra: boolean | undefined;
  trainingPermission?: boolean;
  evaluationId?: number | undefined;
};

export type DispatchSearchParams = {
  vesselId: string | undefined;
  fleetId: string | undefined;
  marinerIds: number[] | undefined;
  ratings: JobRating[] | undefined;
  current: boolean;
};

export type InitialRosterFormJobOrderValues = AtLeast<
  JobOrder,
  | "offsignerDeboarded"
  | "fillByDate"
  | "port"
  | "reliefReason"
  | "offsignerDestination"
  | "onsignerOnboarded"
  | "offsignerNotes"
  | "onsignerNotes"
>;

export type RosterMember = {
  id?: number;
  rating: JobRating;
  dispatch: Dispatch;
  jobOrder: JobOrder;
  initialJobOrder: InitialRosterFormJobOrderValues;
  offsigning: boolean;
  currentDaysOnboard: number;
};

export type TrainingRosterMember = {
  id?: number;
  rating: JobRating;
  dispatch: Dispatch;
  trainingOrders: TrainingOrder[];
}

export type TrainingRosterRow = {
  id?: number;
  rating: JobRating;
  profile: MarinerProfile;
  trainingOrder: TrainingOrder;
  onboarded: boolean;  
  editing: boolean;
}

export enum RosterDetailType {
  DISPATCH = "DISPATCH",
  JOB_ORDER = "JOB_ORDER",
}

//enum for dispatch duration
export enum DispatchDuration {
  REGULAR = "REGULAR",
  SHORT_TERM = "SHORT_TERM",
}

// enum for Roster view
export enum RosterFilter {
  FULL = "FULL",
  FILLED = "FILLED",
  UNFILLED = "UNFILLED",
}
